import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Link from '@material-ui/core/Link';
import { VARIANTS } from 'Components/ComponentLibrary/Atoms/Text';
import theme from 'Theme';

const styles = () => ({
  root: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  inheritedStyles: {
    '&:hover': {
      textDecoration: 'underline',
    },
  },
});

const LinkButton = ({
  className,
  classes,
  children,
  color,
  variant,
  weight,
  onClick,
  test,
}) => {
  return (
    <div className={classes.inheritedStyles} style={{ color }}>
      <Link
        className={classNames(classes.root, className)}
        color={color}
        variant={VARIANTS[variant] || 'body1'}
        weight={weight}
        onClick={onClick}
        component={'a'}
        underline={'hover'}
        test={test}
      >
        {children}
      </Link>
    </div>
  );
};

LinkButton.defaultProps = {
  className: '',
  color: theme.palette.facet.primaryBlue,
  weight: 'bold',
  variant: undefined,
  onClick: () => {},
  test: '',
};

LinkButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  variant: PropTypes.string,
  weight: PropTypes.string,
  onClick: PropTypes.func,
  test: PropTypes.string,
};

export default withStyles(styles)(LinkButton);
